import jwtDecode from "jwt-decode";

import store from "./redux/store";
import { intl } from "../containers/app";
import { handleError } from "./errorLogger";
import { KEYCLOAK_CONFIG } from "../keycloak";
import { error, success, warn } from "./messages";
import { post, checkHttpStatus } from "./httpFunctions";
import { dropUser, setUser } from "./redux/session/actions";

type Credentials = {
  username: string;
  password: string;
};

interface TokenDto {
  foo: string;
  exp: number;
  iat: number;
}

const parseToken = (token: any) => jwtDecode<TokenDto>(token);

/**
 * přihlášeni uživatele
 * @param {Credentials} credentials přihlašovací údaje
 */
export async function signIn(credentials: Credentials) {
  try {
    const response = await post("auth", credentials, false);
    const { data } = response;
    const success = checkHttpStatus(response);
    if (success) {
      saveUserFromKeycloak(data.access_token, data.refresh_token);
    } else {
      error(
        (data && data.message) ||
          intl.formatMessage({
            id: "session.loginError",
            defaultMessage:
              "Server není dostupný, zkuste prosím přihlášení později!",
          })
      );
    }
    return { success };
  } catch (err: any) {
    handleError(err);
    return { success: false };
  }
}

export function saveUserFromKeycloak(
  token: string,
  refreshToken: string,
  parsedToken: any = undefined
) {
  parsedToken = parsedToken || parseToken(token);
  const roles =
    parsedToken.roles && parsedToken.roles[KEYCLOAK_CONFIG.clientId]
      ? parsedToken.roles[KEYCLOAK_CONFIG.clientId]
      : [];
  store.dispatch(
    setUser({
      refreshToken,
      name: parsedToken.name,
      email: parsedToken.email,
      username: parsedToken.preferred_username,
      reader: hasRole(roles, "reader"),
      writer: hasRole(roles, "writer"),
      it: hasRole(roles, "it"),
      roles,
    })
  );
}

/**
 * odhlášeni uživatele
 * @param {boolean} security jestli jde o security logout
 */
export async function signOut(auth: any, security: boolean = false) {
  await Promise.all([store.dispatch(dropUser()), auth.signoutRedirect()]);
  //zavolani se musi posunout, aby se stacil nacist spravny jazyk uzivatele
  setTimeout(
    () =>
      security
        ? warn(
            intl.formatMessage({
              id: "session.securityLogout",
              defaultMessage: "Došlo k bezpečnostnímu odhlášení!",
            })
          )
        : success(
            intl.formatMessage({
              id: "session.logout",
              defaultMessage: "Došlo k odhlášení!",
            })
          ),
    1000
  );
}

/**
 * nastaví poslední lokaci uživatele před nuceným přechodem na přihlášení
 * @param path lokace
 */
export function setLastPath(path: string) {
  sessionStorage.setItem("last-path", path);
}

/**
 * vrátí poslední lokaci uživatele před odhlášením a zároveň ji smaže
 */
export function getLastPath(): string {
  const path = sessionStorage.getItem("last-path") || "/";
  setLastPath("/");
  return path;
}

const hasRole = (roles: string[], role: string) =>
  roles.some((r: string) => r === role);
